import { useEffect, useState } from "react";
import { RewardCard } from "./rewardCard";
import UserAPI from "../../api/UserAPI";

import styles from "./rewards.module.css"
import AdminAPI from "../../api/AdminAPI";
import { Retractable } from "../retractable/retractable";
import { Text } from "../text/text";

export const Rewards = ({ userId }) => {
    const [rewards, setRewards] = useState([]);

    useEffect(() => {
        if (userId) {
            AdminAPI.fetchUserAchieves(userId)
                .then(res => setRewards(res))
                .catch(() => setRewards([]));
        } else {
            UserAPI.fetchUserAchieves()
                .then(res => setRewards(res))
                .catch(() => setRewards([]));
        }
    }, [userId]);

    const rewardTriads = [];
    for (let i = 0; i < Math.ceil(rewards.length / 3); i++) {
        const triad = [];
        for (let j = 0; j < 3; j++) {
            if (i * 3 + j === rewards.length) {
                break;
            }

            triad.push(
                <RewardCard
                    key={i * 3 + j}
                    title={rewards[i * 3 + j].title}
                    subtitle={rewards[i * 3 + j].subtitle}
                    icon={rewards[i * 3 + j].icon}
                />
            )
        }

        rewardTriads.push(
            <div className={styles.reward_triad} key={i}>
                {triad}
            </div>
        );
    }

    return (
        <Retractable active={rewardTriads.length !== 0}>
            <div className={styles.user_rewards_container}>
                <Text tag="div" view="bodyStrong" className={styles.user_rewards_title}>Награды</Text>
                <div className={styles.user_rewards}>
                    {rewardTriads}
                </div>
            </div>
        </Retractable>
    );
}
